import { lazy } from 'react';

export const ListOfEmployeesLazy = lazy(() => import('./ListOfEmployees'));
